import React from 'react';
import { createRoot } from 'react-dom/client';
import './tailwind.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { restoreLocalStorageIfEmpty, startPeriodicBackup, backupLocalStorage } from './utils/localStorageBackup';

const container = document.getElementById('root');

async function init() {
  try {
    // If localStorage is empty (e.g. after kiosk reboot), attempt to restore
    await restoreLocalStorageIfEmpty();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('localStorage restore during init failed', e);
  }

  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }

  // Start periodic backups so changes are persisted
  startPeriodicBackup(30_000);

  // Ensure a final backup on unload (kiosk shutdown)
  window.addEventListener('beforeunload', () => {
    try {
      // synchronous best-effort
      backupLocalStorage();
    } catch (e) {
      // noop
    }
  });

  reportWebVitals();
}

init();